var map = {
	"./apple.svg": 18864,
	"./chrome.svg": 26806,
	"./ellipsis-vertical.svg": 9568,
	"./facebook.svg": 14532,
	"./logout.svg": 20194,
	"./messenger.svg": 34997,
	"./mobile.svg": 51846,
	"./qrcode.svg": 74566,
	"./service.svg": 22401,
	"./share.svg": 80089,
	"./sms.svg": 26519,
	"./telegram.svg": 70849,
	"./tiktok.svg": 97334,
	"./viber.svg": 494,
	"./whatsapp.svg": 83506,
	"./x-twitter.svg": 44134,
	"./youtube.svg": 1451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;